module.exports = __webpack_public_path__ + "img/d6.81416d56.webp";